<div class="relative h-full overflow-hidden rounded-xl">
    <div
            class="flex transition-transform duration-700 ease-in-out"
            [style.transform]="'translateX(-' + currentSlide * 100 + '%)'"
    >
        <div
                *ngFor="let image of componentModel?.banners?.value"
                class="min-w-full"
        >
            <div class="relative w-full rounded-xl overflow-hidden group" >
                <div class="hero-banner absolute w-full h-full bg-cover bg-center bg-no-repeat transition-all duration-300 group-hover:scale-150" style="background-image: url('{{image.imageUrl.value}}')">
                    <div class="bg-black opacity-75 absolute w-full h-full top-0 left-0"></div>
                </div>
                <div class="bottom-1/4 py-24 lg:py-48 relative grid md:grid-cols-2 grid-cols-1 md:left-10 md:text-left text-center">
                    <div>
                        <h2 class="text-20 md:text-60 font-bold text-white">
                            {{image.title.value}}
                        </h2>
                        <p class="text-md md:text-md leading-2 font-light  text-white mt-4 text-wrap overflow-hidden">
                            {{image.description.value}}
                        </p>
                    </div>
                    <div class="flex justify-around items-end">
                        <white-label-button [text]="image.buttonText.value" [link]="image.buttonLink.value"></white-label-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Indicators -->
    <div class="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2">
    <span
            *ngFor="let image of componentModel?.banners?.value; let i = index"
            class="block w-3 h-3 rounded-full"
            [class.bg-white]="currentSlide === i"
            [class.bg-gray-500]="currentSlide !== i"
            (click)="goToSlide(i)"
    ></span>
    </div>
</div>
